<template>
	<div class="page">
		<!-- ${data.hospitalName}医院 -->
		<!-- <p class="title">{{ `${data.departmentName}团队正在对您进行问卷随访，对您的恢复有重要作用，请仔细填写` }}</p> -->
		<p class="label" v-if="data.questionnaireType === 4"
			>随访日期：{{ $moment(data.followUpDate).format('YYYY年MM月DD日') }}</p
		>
		<headerCard class="m-32" :list="headerList" />
		<div class="py-32" v-if="data.feedbackDate">
			<doctorCard
				title="随访反馈"
				:date="data.feedbackDate||''"
				:doctor="doctorDetail"
				:list="[
                    {value:data.feedbackContent,label:''},
                ]"
			/>
		</div>

		<van-form ref="form" show-error-message v-if="list.length > 0">
			<div v-for="question in list" :key="question.id">
				<!-- {{question.beLink}}
                {{showQuestion(question.beLink)}} -->
				<div v-if="showQuestion(question.show)">
					<!-- 主标题 -->
					<template v-if="question.questionType === '61'">
						<g-title :text="question.name" />
					</template>

					<!-- 副标题 -->
					<template v-if="question.questionType === '62'">
						<g-subtitle :text="question.name" />
					</template>

					<!-- 单选题 -->
					<template v-if="question.questionType === '11'">
						<g-radio-group
							v-model="question.value"
							:disabled="disabled"
							:question="question"
							:rule="computedRule(question)"
							@change="updateData"
						/>
					</template>

					<!-- 多选题 -->
					<template v-if="question.questionType === '12'">
						<g-checkbox-group
							v-model="question.value"
							:disabled="disabled"
							:question="question"
							:rule="computedRule(question)"
							@change="updateData"
						/>
					</template>

					<!-- 文本题 -->
					<template v-if="question.questionType === '20'">
						<g-field
							v-model="question.value"
							:disabled="disabled"
							:question="question"
							:rule="computedRule(question)"
							@change="updateData"
						/>
					</template>

					<!-- 文本题 -->
					<template v-if="question.questionType === '21' || question.questionType === '23'">
						<g-field
							v-model="question.value"
							:question="question"
							:disabled="disabled"
							:option="{
                                    name: question.name,
                                }"
							:rule="computedRule(question)"
							@change="updateData"
						/>
					</template>

					<!-- 综合类型题目 可新增 -->
					<template v-if="question.questionType === '24'">
						<g-fuse
							v-model="question.value"
							:disabled="disabled"
							:question="question"
							:rule="computedRule(question)"
							@change="updateData"
						>
						</g-fuse>
					</template>
					<!-- 上传题 -->
					<template v-if="question.questionType === '31'">
						<g-q-upload
							v-model="question.value"
							:disabled="disabled"
							:question="question"
							:rule="computedRule(question)"
							@change="updateData"
						/>
					</template>

					<!-- 日期题 -->
					<template v-if="question.questionType === '41'">
						<g-date
							v-model="question.value"
							:disabled="disabled"
							:question="question"
							:rule="computedRule(question)"
							@change="updateData"
						/>
					</template>
				</div>
			</div>
		</van-form>

		<div class="btn margin-bottom">
			<van-button v-if="page>0" plain block style="margin-right:10px" type="primary" @click.self="pref"
				>上一步</van-button
			>
			<van-button v-if="disabled?false:true" block type="primary" @click.self="submit">{{submitText}}</van-button>
		</div>
	</div>
</template>

<script>
import { Toast } from 'vant'
import { mapActions, mapState } from 'vuex'

// import api from '@/http/api'
import riskForm from './risk-form'
import baseForm from './form'
import headerCard from './components/form-header.vue'
import doctorCard from '../report-manage/components/report-doctor-card.vue'
// import { get } from 'http';
// var _ = require('lodash');
export default {
    components: { headerCard, doctorCard },
    name: 'QuestionDetail',
    metaInfo: {
        title: "问卷详情"
    },
    data () {
        return {
            result: "ssd",
            index: 0,
            showNotify: false,
            showUserAnswer: false,
            question: {},
            data: {
                questionList: []
            },
            list: [],
            done: false,
            page: 0,
            // info: {},
            doctorDetail: {}
        }
    },
    created () {
        // this.list = form.form[0]
        this.getData();
    },
    computed: {
        ...mapState(['userInfo', 'appid', 'preview', 'project']),

        ...mapState(['again']),
        submitText () {
            // return this.page+1 == this.list.length?'提交' : '下一步'
            return '提交'
        },
        getUrl () {
            return {
                0: this.getDetailForAnswer,
                1: this.getAnswer,
            }
        },
        type () {
            return this.$route.params.type
        },
        questionnaireId () {
            return this.$route.query.id || this.$route.params.id
        },
        disabled () {
            return (this.type !== 'patient') || ([2, 3, 4].indexOf(this.data.reviewStatus) > -1)
        },
        update () {
            return true
        },
        patientId () {
            return this.data.patientId
        },
        headerList () {
            const { patientName, mainDiagnosis, followUpDate } = this.data
            let arr = [
                { label: '患者姓名：', value: patientName }
            ]
            if (this.data.questionnaireType === 4) {
                arr.push({ label: '出院诊断：', value: mainDiagnosis })
            }
            if (this.data.questionnaireType === 5) {
                arr.push({ label: '随访日期：', value: this.$moment(followUpDate).format('YYYY年MM月DD日') })
            }
            return arr
        },
        storageKey () {
            return 'case_' + this.data.id
        }
    },
    methods: {
        ...mapActions(['getDetailForAnswer', 'getAnswer', 'submitQuestionnaire', 'updateQuestionnaire']),

        getData () {
            let func = this.$api.followUp.getInfoNoToken
            if (this.type === 'patient') {
                func = this.$api.followUp.getFollowUpDetail
            }
            func(this.questionnaireId).then(({ data }) => {
                this.data = data;

                //获取患者医生详情
                // this.getPatientDetail()
                this.getDoctorDetail()

                if (data.answerContent) {
                    this.list = JSON.parse(data.answerContent)
                } else {
                    // TODO：判断患者的类型 用this.info

                    this.list = JSON.parse(JSON.stringify(data.questionnaireType === 4 ? baseForm.form[0] : riskForm.form[0]))
                    // 初始化血脂水平的值
                    if (this.type !== 'doctor') {
                        this.initForm()
                    }
                }

            }).catch(() => { })
        },
        async initForm () {
            const { code, data } = await this.$api.indicator.bloodFatLastInfo({ patientId: this.data.patientId })
            if (!code && data) {
                let index = this.list.findIndex(v => ['input_17', 'input_9_1'].indexOf(v.locationKey) > -1)
                if (index > -1) {
                    this.list[index].optionList[2].value = data.triglycerides
                    this.list[index].optionList[1].value = data.lowDensityFat
                }
            }

        },
        // getPatientDetail () {
        //     this.$api.patient.getPatientInfo(this.data.patientId).then(({ code, data }) => {
        //         if (!code) {
        //             this.info = data
        //         }
        //     })
        // },

        getDoctorDetail () {
            if (!this.data.doctorId) {
                return
            }
            this.$api.doctor.getDoctorInfoById(this.data.doctorId).then(({ code, data }) => {
                if (!code) {
                    this.doctorDetail = data
                }
            })
        },

        // 处理问卷数据
        // -选择提： 单选和多选在问题上增加了optionId用来保存用户选择的选项，单选：""，多选：[]
        // -多项文本题：optionList中增加answerContent用来存储用户输入的文本消息
        // -文本题：问题中增加answerContent用来存储用户输入的文本消息
        // -日期题，上传题，问题中增加answerContent用来存储用户选择的日期或者上传的文件链接
        handleData (dataArr) {
            if (this.update) return;
            dataArr.forEach(item => {
                const defaultOption = item.optionList.find(option => option.defaultFlag === 1);
                switch (item.questionType) {
                    // 单选
                    case '11':
                        item.optionId = defaultOption ? defaultOption.id : "";
                        break;
                    // 多选
                    case '12':
                        item.optionId = [];
                        break;
                    // 文本题
                    case '20':
                        item.answerContent = "";
                        break;
                    // 多项短文本，23
                    case '21':
                    case '23':
                        item.optionList.forEach(o => {
                            o.answerContent = "";
                        })
                        break;
                    // 上传文件
                    case '31':
                    case '32':
                        item.answerContent = []
                        break;
                    // 41 日期题
                    case '41':
                        item.answerContent = ""
                        break;
                    // 51 矩阵文本
                    default:
                        break;
                }
            })
        },

        updateData () {
            console.log(this.list)
            this.data = { ...this.data };
            this.list = [...this.list];
            localStorage.setItem(this.storageKey, JSON.stringify(this.list))
        },

        computedRule (question) {
            const rules = [];
            // 11 单选题，12 多选题，20 文本题，23 多项短文本，24 综合类型题目,31 上传题， 41 日期题
            if (question.mustAnswer === 1) {
                rules.push({ required: true, message: question.mustAnswerTips || '内容不能为空' })
            }

            switch (question.questionType) {
                case '11':
                case '12':
                    break;
                case '20':
                    if (question.verifyMin !== null || question.verifyMax !== null) {
                        rules.push({ max: question.verifyMax, min: question.verifyMin, message: question.mustAnswerTips })
                    }
                    break;
                case '21':
                    break;
                default:
                    break;
            }
            return rules;
        },

        setArrSort (arr, targetIndex, originIndex) {
            const origin = arr.splice(originIndex, 1)
            arr.splice(targetIndex, 0, ...origin)
        },

        handleSubmitData () {
            return this.list.map(res => {
                if (['31', '32'].includes(res.questionType)) {
                    res.answerContent.forEach(i => {
                        i.content = ""
                    })
                    return res;
                } else {
                    return res
                }
            })
        },
        //是否展示该问题
        showQuestion (beLink) {
            if (beLink.length > 0) {
                let ret = false
                beLink.map(v => {
                    let obj = this.list.find(r => r.locationKey == v.questionId)
                    if (obj.value === v.answer) {
                        ret = true
                    }
                })
                return ret
            } else {
                return true
            }

        },
        //上一步
        pref () {
            this.page -= 1
        },
        submit () {
            // 预览模式禁止提交
            if (this.preview === '1') {
                Toast('预览模式不可提交');
                return;
            }
            console.log(this.list)


            this.$refs.form.validate().then(() => {
                const data = JSON.stringify(this.list);
                let obj = {}
                // let paramsArr = this.list.map(v=>v.content)
                //     paramsArr  =  paramsArr.flat()
                this.list.map(v => {
                    if (v.propName) {
                        obj[v.propName] = v.answerContent || v.optionId
                    }
                })
                this.$dialog.confirm({
                    title: '提示',
                    message: '提交后不可修改，是否确认提交',
                }).then(() => {
                    this.$api.followUp.addFollowUp({
                        id: this.questionnaireId,
                        answerContent: data,

                    }).then(({ code }) => {
                        let _this = this
                        if (!code) {
                            Toast({
                                message: '提交成功',
                                onClose: () => {
                                    _this.getData()
                                }
                            })
                        } else {
                            if (code === 20031) {
                                Toast({
                                    message: '问卷已被其他账号提交',
                                    onClose: () => {
                                        _this.$router.replace({
                                            path: '/main/home/visits'
                                        })
                                    }
                                })
                            }
                        }

                    }).catch(() => {
                        Toast.clear()
                    })
                }).catch((err) => {
                    console.log(err)
                    this.$toast('已取消提交')
                })
            }).catch((error) => {
                console.log(error)
                this.$toast('您有未填写信息')
            })
        }
    }
}
</script>

<style lang="less" scoped>
.page {
	width: 100vw;
	min-height: 100vh;
	background: #f6f7f8;

	.notify {
		display: block;
		background: #e8effd;
		padding: 3.733vw 4.267vw;
		font-size: 3.733vw;
		line-height: 1.5;
		color: #2267f2;
		margin: 0;
	}
	.label {
		color: @gray-9;
		font-size: 26px;
		text-align: center;
		margin-top: 20px;
	}
	.title {
		text-align: center;
		padding: 40px 32px 0 32px;
		font-size: 32px;
		line-height: 44px;
		color: #1f2329;
		font-weight: bold;
		margin: 0;
		word-break: break-all;
	}

	.quetion-box {
		padding: 5.333vw 4.267vw;

		& > p {
			font-size: 4.533vw;
			font-weight: 500;
			color: #000000;
			line-height: 6.4vw;
		}

		& > div {
			background: #ffffff;
			border-radius: 2.667vw;
			margin-top: 3.733vw;

			/deep/ .question-option {
				padding: 4.8vw 4.267vw;
				font-size: 4vw;
				font-weight: 500;
				color: #333333;
				line-height: 5.6vw;

				.label {
					margin-bottom: 2.667vw;
				}
			}
		}
	}

	.btn {
		margin-top: 13.867vw;
		padding: 0 4.267vw;
		box-sizing: border-box;
		display: flex;
		&.postion-bottom {
			width: 100%;
			position: fixed;
			bottom: 10.133vw;
			left: 0;
		}

		&.margin-bottom {
			padding-bottom: 4vw;
		}
	}
}
.van-field {
	padding: 0;
}
.m-32 {
	margin: 32px;
}
.py-32 {
	padding: 0 32px;
}
</style>
